<template>
  <div class="resultSignature_warpper">
    <nav-bar titleText="签名结果" titleWeight="bold" @goBack="closeContractSigned"></nav-bar>
    <results-page @handleOperationClick="closeContractSigned" @handleReturnClick="closeContractSigned" operationDisplab
      operationText="完成" returnDisplab returnText="返回" :imgSrc="imgSrc" :instructions="instructionsTxt"></results-page>
  </div>
</template>
<script>
  import navBar from "./components/navBar";
  import resultsPage from "../debtRelief/components/resultsPage";
  export default {
    data() {
      return {
        imgSrc: require("../../assets/debtor/inProcess.png"),
        role: '',
        instructionsTxt: ''
      };
    },
    created() {
      this.role = this.$route.query.role
      if (this.role == 1) {
        this.instructionsTxt = '等待房东签署合同'
      }
      if (this.role == 2) {
        this.instructionsTxt = '等待租客签署合同'
      }
      if (this.role == 4) {
        this.instructionsTxt = `签署成功,等待租客签署服务合同`
      }
    },
    components: {
      navBar,
      resultsPage,
    },
    methods: {
      closeContractSigned() {
        this.params('success', 'success', 'closeContractSigned');
      },
      // handleOperationClick() {
      //   this.params('success', 'success', 'closeContractSigned');
      // },
      // handleReturnClick() {
      //   this.params('success', 'success', 'closeContractSigned');
      // }
    }
  }
</script>
<style lang="less">
  .resultSignature_warpper {
    padding-top: 88px;
    box-sizing: border-box;
    background-color: #f5f6f7;
    min-height: 100%;
    font-size: 16px;
    color: #333;
  }

  .return {
    display: none !important;
  }
</style>